export const LOAD_CUSTOMERUSERS_SUCCESS = "LOAD_CUSTOMERUSERS_SUCCESS";

export const CREATE_CUSTOMERUSER_SUCCESS = "CREATE_CUSTOMERUSER_SUCCESS";

export const SAVE_CUSTOMERUSER_SUCCESS = "SAVE_CUSTOMERUSER_SUCCESS";

export const DELETE_CUSTOMERUSER_SUCCESS = "DELETE_CUSTOMERUSER_SUCCESS";

export const LOAD_CUSTOMERUSER_DETAIL_SUCCESS = "LOAD_CUSTOMERUSER_DETAIL_SUCCESS";

export const ACTIVATE_CUSTOMERUSER_SUCCESS = "ACTIVATE_CUSTOMERUSER_SUCCESS";

export const DEACTIVATE_CUSTOMERUSER_SUCCESS = "DEACTIVATE_CUSTOMERUSER_SUCCESS";

export const CREATE_CUSTOMERUSER = "CREATE_CUSTOMERUSER";
export const SAVE_CUSTOMERUSER = "SAVE_CUSTOMERUSER";
